<template>        
    <div class="ibox custom-box h-100 mb-0" v-if="is_dashboard == 'yes'">
        <div class="ibox-title dashboard_title">
            <div class="content-div-title">Leave Balances</div>
        </div> 
        <div class="dash-ibox-content mt-3">
            <div class="leave-balance-info border-bottom p-2" v-for="leave_type in leave_available" :key="leave_type.id">
                <span class="title">
                    <b-icon :icon="leave_type.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                    {{leave_type.leave_title}}
                </span>
                <span class="float-right">{{leave_type.remaining_days}}</span>
            </div>
    <div class="leave-req-wrapper" v-if="is_dashboard == 'yes'">
        <div class="content-div-title mb-3 mt-4">Recent Leave Requests</div>
        <template v-if="count_leaves > 0">
            <table class="">
                <thead>
                    <tr class="table-head">
                        <th class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" style="cursor:pointer;">{{column.label}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row" v-for="(leave,n) in leaves" :key="n" v-if="n < 3">
                        <td class="font-semi-bold">
                            <b-icon :icon="leave.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                            {{leave.leave_type}}
                        </td>
                        <td class="text-center font-semi-bold">{{leave.from}}</td>
                        <td class="text-center font-semi-bold">{{leave.to}}</td> 
                        <td class="text-center font-semi-bold">
                            <template v-if="leave.leave_day == 0">                                    
                                {{leave.number_of_days}} 
                                <span v-if="leave.number_of_days > 1">days</span>
                                <span v-else>day</span>
                            </template>
                            <template v-else-if="leave.leave_day == 1">First Half</template>
                            <template v-else-if="leave.leave_day == 2">Second Half</template>
                        </td>
                        <td class="text-center font-semi-bold" :class="leave.status.toLowerCase()">
                            <span class="leave-status" v-if="leave.status == 'Applied'"><i class="fa fa-circle mr-1"></i>Pending</span>
                            <span class="leave-status" v-if="leave.status == 'Approved'"><i class="fa fa-circle mr-1"></i>{{leave.status}}</span>
                            <span class="leave-status" v-if="leave.status == 'Declined'"><i class="fa fa-circle mr-1"></i>{{leave.status}}</span>
                        </td>
                    </tr>										
                </tbody>
            </table>
        </template>
        <template v-else>        
            No Leave Request Found.        
        </template>
    </div>
    <div class="ibox custom-box" v-else>
        <div class="ibox-title dashboard_title">
            <h3>
                <img class="m-r-sm" :src="img_src + 'position.png'" width="16">
                Recent Leave Requests
            </h3>
        </div>
        <div class="ibox-content">
            <template v-if="count_leaves > 0">
                <table class="table dataTable"> 
                    <thead class="" style="">
                        <tr class="table-head">
                            <td class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" style="cursor:pointer;">{{column.label}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        
                            <tr class="table-row hover-bg" v-for="(leave,n) in leaves" :key="n">
                            
                                <td class=""> 
                                    <b-icon :icon="leave.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                                    {{leave.leave_type}}
                                </td>
                                <td class="">
                                    {{leave.from}} 
                                </td>
                                <td class="">                                    
                                    {{ leave.to }}
                                </td>
                                <td class="text-center font-semi-bold">
                                    <template v-if="leave.leave_day == 0">                                    
                                        {{leave.number_of_days}} 
                                        <span v-if="leave.number_of_days > 1">days</span>
                                        <span v-else>day</span>
                                    </template>
                                    <template v-else-if="leave.leave_day == 1">First Half</template>
                                    <template v-else-if="leave.leave_day == 2">Second Half</template>
                                </td>                                  
                                <td class="">
                                    <span class="leave-status" v-if="leave.status == 'Approved'"><i class="far fa-dot-circle mr-1 text-success"></i>{{leave.status}}</span>
                                    <span class="leave-status" v-if="leave.status == 'Applied'"><i class="far fa-dot-circle mr-1 text-primary"></i>Pending</span>
                                    <span class="leave-status" v-if="leave.status == 'Declined'"><i class="far fa-dot-circle mr-1 text-danger"></i>{{leave.status}}</span>
                                </td>                                                           
                        </tr>
                    </tbody>
                </table>
            </template>
            <template v-else>
            
                No Leave Request Found.
            
            </template>
        </div>
    </div>
            
            <div class="text-center"><button @click="setMe('roster-employee-front')" class="dashboard-more-btn custom-primary-btn">View More</button></div>
        </div>
    </div>
    <div class="ibox custom-box" v-else>
        <div class="ibox-title dashboard_title">
            <h3>
                <img class="m-r-sm" :src="img_src + 'position.png'" width="16">
                Leave Balances
            </h3>
        </div>
        <div class="ibox-content">
            <template v-if="count_leave_available >0">
                <table class="table dataTable">
                    <thead>
                        <tr class="table-head">
                            <td>Leave Category</td>
                            <td>Total Allocated Leaves</td>
                            <td>Remaining Leaves</td>
                        </tr>
                    </thead>
                    <tbody>
                        
                        <tr class="table-row hover-bg" v-for="leave_type in leave_available" :key="leave_type.id">
                            
                                <td>
                                    <b-icon :icon="leave_type.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                                    {{leave_type.leave_title}}
                                </td>
                                <td>{{leave_type.leave_days}} Days</td>
                                <!-- <td>{{leave_type.remaining_days}} Days</td> -->
                                <td>
                                    <template v-if="leave.leave_day == 0">                                    
                                        {{leave.number_of_days}} 
                                        <span v-if="leave.number_of_days > 1">days</span>
                                        <span v-else>day</span>
                                    </template>
                                    <template v-else-if="leave.leave_day == 1">First Half</template>
                                    <template v-else-if="leave.leave_day == 2">Second Half</template>
                                </td>
                            
                        </tr>
                        
                        
                    </tbody>
                </table>
            </template>
            <template v-else>                                             
                No Leave Policy Assigned.  
            </template>
        
        </div>
    </div>
</template>
<script> 
  
    let sortOrders = {};
    let columns = [
                    
                    {label: 'Leave Category', name: 'leave_type'},
                    {label: 'From', name: 'from'},
                    {label: 'To', name: 'to'},
                    {label: 'No. of Days', name: 'number_of_days'},
                    {label: 'Status', name: 'status'},
                    
                ];
    export default{
      mounted() {
        },

        props: ['is_dashboard'],
        components: {
        },
        data(){

            return {
                leave_available : [],
                count_leave_available : 0, 
                leaves:[],
                leavetypes : [],
                img_src : this.$api_url+'/images/employee_dasboard/', 
                page: { month: '', year: '' },   
                columns: columns,
                sortOrders: sortOrders,
                leaves:[],
                count_leaves : 0,
                cr : 0,
                page: { month: '', year: '' },
                img_src : this.$api_url+'/images/employee_dasboard/',     
            };
        },
        methods:{
            
            
        getRecentLeaves: function()
        {
            if(!this.checkNet()) return false;

            this.employee_id = 0;
            let currentObj = this;
            axios.get(this.$api_url+'/front/leave-attendance/employee/leaves/year' , {
                params: {
                    flg: 1
                }
            }).then(function(response){
                this.leaves = response.data.leaves;
                this.count_leaves = response.data.leaves.length;
                console.log(this.count_leaves);
                
            }.bind(this)).catch(function (error){ currentObj.serverError(error);});
        },

        getLeaves:function() 
        {   
            
            axios.get(this.$api_url+'/front/leave-attendance/employee/leaves' , {
                params: {
                    //id: x
                }
            }).then(function(response){
                
                if(response.data.length != 0)
                {                    
                    this.leave_limit = response.data.limit;

                    this.leave_available = response.data.available;
                    this.count_leave_available = response.data.available.length;

                    if(this.leaves.length == 0)
                    {
                        this.blankmsg = 'Looks like no leave applied for the employee yet.';
                    }

                    
                }       
                
            }.bind(this));

        },
            
        setMe :function(x)
        {
            
            
            if(x == 'request-leave')            
                this.$bvModal.show('bv-modal-leave');
            else
            {            
                let childdata = {component_name:x};                    
                this.$emit('childToParent', childdata);
            }
            
        },
            
            
        },
        created: function(){
            this.getLeaves();
            this.getRecentLeaves();       
        },
 
    }

</script>